import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    interestAccrued: {
        id: '_.outstanding_view.interestAccrued',
        defaultMessage: 'Interest'
    },
    outstandingBalance: {
        id: '_.outstanding_view.outstandingBalance',
        defaultMessage: "Today's outstanding balance"
    },
    currentPrincipal: {
        id: '_.outstanding_view.currentPrincipal',
        defaultMessage: 'Current principal'
    },
    borrowedAmount: {
        id: '_.outstanding_view.borrowedAmount',
        defaultMessage: 'Borrowed Amount'
    },
    creditLimit: {
        id: '_.outstanding_view.creditLimit',
        defaultMessage: 'Credit limit'
    },
    creditLimitApproved: {
        id: '_.outstanding_view.creditLimitApproved',
        defaultMessage: 'Approved Credit limit'
    },
    creditLimitToolTipMessage: {
        id: '_.outstanding_view.creditLimitToolTipMessage',
        defaultMessage:
            'You borrowed {loanAmount} of your {creditLimit} credit limit on {drawDownDate}'
    },
    faqIncreaseLoanTitle: {
        id: '_.outstanding_view.faqIncreaseLoanTitle',
        defaultMessage: 'Can I request more funds?'
    },
    faqIncreaseLoanDescription: {
        id: '_.outstanding_view.faqIncreaseLoanDescription',
        defaultMessage:
            'You can make a request once your <strong>principal is below two thirds of your credit limit</strong> - e.g. £20k if your limit is £30k.{linebreak}{linebreak} You can request a new credit limit <strong>up to £500k</strong>, and we’ll give you a decision within <strong>1 business day</strong> based on updated info like bank statements. If you’re requesting up to £15k we’ll give you an <strong>instant decision</strong>.{linebreak}{linebreak} When you take more funds, you’ll have <strong>another <span>{months}</span> months</strong> to pay off the loan.'
    },
    faqEarlyRepaymentsTitle: {
        id: '_.outstanding_view.faqEarlyRepaymentsTitle',
        defaultMessage: 'How do early repayments work?'
    },
    faqEarlyRepaymentsDescription: {
        id: '_.outstanding_view.faqEarlyRepaymentsDescription',
        defaultMessage: `If you repay more than your agreed monthly repayment, you’re technically repaying early – <strong>there’s no fee for that</strong>.{linebreak}{linebreak}  You can do it as a one-off via instant bank transfer, your linked debit card, or manual transfer.{linebreak}{linebreak}  When you do, you can either pay off your full loan there and then, or give yourself a
        <strong>repayment break</strong> - e.g. if your monthly payment is £1,000 a month, and you repay £3,000 one month, you’ll have two months off.  (You’ll still accrue interest for this time, though.)`
    },
    decideLater: {
        id: '_.outstanding_view.outstanding.decide_later',
        defaultMessage: 'Back'
    },
    docsRequiredAlertBox: {
        id: '_.outstanding_view.outstanding.docsRequiredAlertBox',
        defaultMessage:
            'We need some documents from you to complete your top up'
    },
    docsRequiredAlertBoxCTA: {
        id: '_.outstanding_view.outstanding.docsRequiredAlertBoxCTA',
        defaultMessage: 'Upload Now'
    },
    checkingDocsRequiredAlertBox: {
        id: '_.outstanding_view.outstanding.checkingDocsRequiredAlertBox',
        defaultMessage: 'We are just checking if we need any docs from you'
    }
});
